class Mapplic {
	constructor() {
		this.id = "276";
		// this.id = "266";

		this.mapplic = $(".mapplic-element"); // Needs id ..
		this.self = this.mapplic.data("mapplic");
		console.log(this.mapplic);

		if (!this.mapplic) return;

		// Event mapplic to bind events

		this.mapplic.one("click", () => {
			console.log("BIEN RECU");
			console.log("PENSER A REMETTRE LE SCRIPT ORIGINAL");
			this.init();
		});

		this.mapplic.on("mapready", () => {
			this.init();
		});
		console.log("BIND");

		$(document).on("truc.locationopened", function(e, location) {
			// location grants full access to the location
			console.log(location.title + " opened.");
		});

		$(".header").on("click", function() {
			$(".header").trigger("ima");
		});

		$(".header").on("ima", function() {
			console.log("dd");
		});

		// this.mapplic.on("locationopened", function(e, location) {
		// 	// location grants full access to the location
		// 	console.log(location.title + " opened.");
		// });
	}

	init() {
		console.log("Mappplic::init");

		this.initEvents();
	}

	initEvents() {
		// $(".mapplic-pin")
		// 	.on("mouseenter", this.onToggle)
		// 	.on("mouseleave", this.onToggle);

		$("#MAP_ZONE_3, #MAP_ZONE_2, #MAP_ZONE_1").on("click", e => {
			const el = $(e.currentTarget);

			console.log(el.attr("id"));
			console.log(this.self);
			this.self.showLocation(el.attr("id"));
		});
	}

	onToggle(e) {
		// Custom background color
		// let attr = $(e.currentTarget).attr("data-location");
		// $(".mapplic-map-image")
		// 	.find("#" + attr)
		// 	.toggleClass("is--hover");
	}
}
